import React from 'react'
import MailchimpSubscribe from 'react-mailchimp-subscribe'

// import { Parallax } from 'react-scroll-parallax'

import Layout from '../components/layout'

// import ImageiPhone from '../images/iphone.png'

import IconMobilePayment from '../images/icons/mobile-payment.svg'
import IconCheckmark from '../images/icons/checkmark-filled.svg'
import IconPayments from '../images/icons/payments.svg'
import IconPartner from '../images/icons/partner.svg'
import IconSmile from '../images/icons/smile.svg'
import IconDone from '../images/icons/done.svg'

const SectionLabelClass = 'dib relative w-100 brand-blue ttu tracked f4'
const MailchimpSubURL =
  'https://Paytm.us15.list-manage.com/subscribe/post?u=75843a7e689ca932e788c4fe4&amp;id=837a41c07d'
const dollarAmount = '$10,000'

class StartPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      getStarted: false,
      benefits: [
        {
          description: `Accept debit & credit card payments quickly and securely`,
          key: 0,
        },
        {
          description: `Request payment from your customers via SMS or Email`,
          key: 1,
        },
        { description: `No set up cost or monthly charges`, key: 2 },
        { description: `Competitive pricing`, key: 3 },
      ],
      how: [
        {
          description:
            'Sign up to get access to our Paytm for Business product on Day 1, when it launches.',
          title: '1. Be a launch partner',
          icon: IconPartner,
        },
        {
          description:
            'Request payments from your customers over SMS / Chat / Email through your own personalized link.',
          title: '2. Request payments',
          icon: IconMobilePayment,
        },
        {
          description:
            'Allow multiple payment methods including Credit cards and Debit cards* payments and receive the funds directly in your bank account.',
          title: '3. Accept multiple payment methods',
          icon: IconPayments,
        },
        {
          description: `No processing fee for the first ${dollarAmount} of sales on your platform.`,
          title: '4. No processing fees',
          icon: IconSmile,
        },
      ],
    }
  }

  handleGetStarted() {
    this.setState({
      getStarted: true,
    })
  }

  render() {
    const { getStarted, benefits } = this.state

    const MailchimpSubForm = ({ status, message, onValidated }) => {
      let email, fName, lName, bName
      const submit = () =>
        email &&
        fName &&
        lName &&
        bName &&
        email.value.indexOf('@') > -1 &&
        onValidated({
          EMAIL: email.value,
          FNAME: fName.value,
          LNAME: lName.value,
          BIZNAME: bName.value,
        })
      return (
        <div className="dib relative w-100 tl">
          <h2 className="dib relative w-100 mv0">Join our waitlist</h2>
          <p className="dib relative w-100 measure-wide gray mb4">
            We'll be in touch when we're ready to bring you on our network.
          </p>
          <div className="dib relative w-100 mb3">
            <input
              placeholder="Your first name"
              className="dib relative w-100 ph3 pv3 br3 bg-near-white black"
              type="text"
              ref={node => (fName = node)}
            />
          </div>
          <div className="dib relative w-100 mb3">
            <input
              placeholder="Your last name"
              className="dib relative w-100 ph3 pv3 br3 bg-near-white black"
              type="text"
              ref={node => (lName = node)}
            />
          </div>
          <div className="dib relative w-100 mb3">
            <input
              placeholder="Your email address"
              className="dib relative w-100 ph3 pv3 br3 bg-near-white black"
              type="email"
              ref={node => (email = node)}
            />
          </div>
          <div className="dib relative w-100 mb3">
            <input
              placeholder="Name of your business"
              className="dib relative w-100 ph3 pv3 br3 bg-near-white black"
              type="text"
              ref={node => (bName = node)}
            />
          </div>
          <button
            className="dib relative w-100 link dim pointer ph3 ph4-ns pv2 pv3-ns f6 f5-ns b bg-brand-navy white br3"
            onClick={submit}
          >
            Join waitlist
          </button>
        </div>
      )
    }

    const SignupForm = ({ className }) => (
      <div className={className || `dib relative w-100`}>
        <div className="dib relative w-100">
          <MailchimpSubscribe
            url={MailchimpSubURL}
            render={({ subscribe, status, message }) => (
              <div className="dib relative w-100 mailchimp">
                {!status ? (
                  <MailchimpSubForm
                    onValidated={formData => subscribe(formData)}
                  />
                ) : null}
                {status === 'sending' && (
                  <div className="dib relative w-100 tc white pa3">
                    Sending...
                  </div>
                )}
                {status === 'error' && (
                  <div
                    className="dib relative w-100 tc yellow pa3"
                    dangerouslySetInnerHTML={{ __html: message }}
                  />
                )}
                {status === 'success' && (
                  <div className="dib relative w-100">
                    <div className="db center w4 pa3">
                      <img
                        className="dib relative w-100"
                        src={IconDone}
                        alt="All done!"
                      />
                    </div>
                    <p className="dib relative w-100 f6 f5-ns b inherit tc">
                      We'll be in touch!
                    </p>
                  </div>
                )}
              </div>
            )}
          />
        </div>
      </div>
    )

    return (
      <Layout>
        {/* Explainer */}
        <section
          className="dib dt-l relative vh-100-l w-100 f5 white tl lh-copy overlay cover bg-merchants-3"
          id="start"
        >
          <div className="dtc v-mid">
            <div className="center mw9 ph3 ph5-ns pv6 relative z-1">
              <div className="row middle-xs">
                <div className="col-xs-12 col-md-7">
                  <h1 className="dib relative w-100 b f3 f2-l measure-wide center mt0 mb3">
                    Receive payments simply and securely.
                  </h1>
                  <div className="dib relative w-100">
                    <p className="dib relative w-100 fw5 f5 f4-l measure center mb4 o-90">
                      Paytm for Business offers an end to end digital payments
                      solution for all types of businesses. Join the waitlist
                      today to take advantage of our pre-launch offer!
                    </p>
                    <ul className="dib relative w-100 measure list mh0 mt0 mb4 pa0 o-90">
                      {benefits.map(item => {
                        return (
                          <li className="dib realtive w-100 mb2">
                            <img
                              className="dib relative v-mid checkmark mr2"
                              alt="Checkmark"
                              src={IconCheckmark}
                            />{' '}
                            {item.description}
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-xs-12 col-md-5">
                  <div className="dib relative w-100 bg-white shadow-light pa4 br3">
                    {getStarted ? (
                      <SignupForm className="dib relative w-100 brand-navy" />
                    ) : (
                      <div className="dib relative w-100 brand-navy">
                        <strong className={SectionLabelClass}>
                          Pre-launch offer
                        </strong>
                        <div className="dib relative w-100 mb3">
                          <p className="dib relative w-100 f4 mb0">
                            Pay $0 in fees on your first <u>{dollarAmount}</u>{' '}
                            of processed payments
                          </p>
                          <p className="dib relative w-100 f6 o-80">
                            Terms &amp; conditions apply.
                          </p>
                        </div>
                        <button
                          className="dib relative w-100 link dim pointer ph3 ph4-ns pv2 pv3-ns f6 f5-ns b bg-brand-navy white br3 tc"
                          onClick={() => this.handleGetStarted()}
                          type="button"
                        >
                          Get started
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Terms */}
              <div className="dib relative absolute-l bottom-0 right-0 left-0 mt5 mt0-ns mh3 mh5-ns">
                <p className="dib relative w-100 f7 o-90">
                  Terms and conditions: You will receive the cash back
                  equivalent of fees paid on the first CAD {dollarAmount}{' '}
                  processed only once you have crossed that threshold. If in
                  your first year of accepting payments you fail to process CAD{' '}
                  {dollarAmount}, no fees will be reimbursed. All applications
                  are subject to Paytm’s approval, including, without
                  limitation, credit approval and entering into a standard form
                  Paytm Merchant Agreement. Other conditions may apply, and
                  Paytm reserves the right to discontinue or terminate this
                  offer at any time.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* How */}
        {/* <section
          className="dib relative w-100 bg-brand-near-white brand-navy lh-copy overflow-hidden tc tl-ns"
          id="learn"
        >
          <div className="center mw8 ph3 ph5-ns pv5 pv6-ns relative">
            <h2 className="b f3 f2-ns measure-wide center mb5">
              How does it work?
            </h2>
            <div className="row middle-xs">
              <div className="col-xs-12 col-md-8">
                {how.map((object, index) => {
                  return (
                    <div className="dib relative w-100" key={Math.random()}>
                      <div className="dib relative measure">
                        <img
                          className="db relative w3 mb4 center mh0-ns"
                          src={object.icon}
                          alt={object.title}
                        />
                        <strong className="f4">{object.title}</strong>
                        <p className="dib relative w-100 gray f5">
                          {object.description}
                        </p>
                      </div>
                      {index < 3 ? (
                        <hr className="center mh0-ns mw3 mv4 mv5-ns bt bw1 b--black-10" />
                      ) : null}
                    </div>
                  )
                })}
              </div>
              <div className="col-xs-12 col-md-4 tc">
                <Parallax offsetYMax={10} offsetYMin={-40} className="store">
                  <img
                    className="dib relative w-100"
                    src={ImageiPhone}
                    alt="QR Code Payments"
                  />
                </Parallax>
              </div>
            </div>
          </div>
        </section> */}
      </Layout>
    )
  }
}

export default StartPage
